// theme.js
import { createTheme } from '@mui/material/styles';

// Light Theme
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2', // Custom primary color for light theme
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: '#f4f6f8', // Light background
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
});

// Dark Theme
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#000', // Custom primary color for dark theme
    },
    secondary: {
      main: '#000',
    },
    background: {
      default: '#000', // Dark background
      paper: '#1e1e1e',
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
});
